// extracted by mini-css-extract-plugin
module.exports = {"band":"style_band__2MyaA"};